/**
 * @author Hakim
 */
export enum MarkerTypeEnum {
  ENTRANCE = 'ENTRANCE',
  EXIT = 'EXIT',
  BORDER = 'BORDER',
  INFO = 'INFO',
  WARNING = 'WARN',
}
